import List from '@components/LanguageManagement/List/List'
import React from 'react'
import LanguageManagement from './LanguageManagement/LanguageManagement'
import requireAuthentication from '@components/AuthenticatedComponent'

function Home() {
  return (
    <div>
      <LanguageManagement/>
      <List/>
    </div>
  )
}

export default requireAuthentication(Home);
